
import Vue from "vue";
import AppFileUpload from "../FileUploadDropAndProgress.vue";
import { AuthService } from "../../services/auth-service";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { HttpError } from "@/utils/services/http-error";
import { PriceListProductService } from "@/services/price-list-product-service";
import { MODULE } from "@/config/modules";
import { ProductCSVImportProductMatchingMethod } from "@/services/product-service";
import { Contact } from "@/models/base";
import AppContactSearch from "@/components/contacts/ContactSearchWithBrowse.vue";
import AppProductMatchingMethodSelect from "./ProductMatchingMethodSelect.vue";

export default Vue.extend({
	data() {
		return {
			file: null as null | File,
			uploading: false,
			useCommaSeperator: false,
			productMatchingMethod: ProductCSVImportProductMatchingMethod.SKU,
			supplier: null as null | Contact
		};
	},
	props: {
		initialFile: {
			type: [File, Blob]
		}
	},
	computed: {
		isAllowed() {
			return AuthService.hasModule(MODULE.EXTERNE_PRODUCT_CATALOGUS);
		},
		allowedExtensions():string[] {
			return ["csv", "txt", "xlsx", "xls", "ods"];
		},
		isExcelFile():boolean {
			if (!this.file) return false;
			return this.file.type.toLowerCase().startsWith("application/");
		}
	},
	watch: {
		initialFile: {
			immediate: true,
			handler(){
				if (this.initialFile){
					this.file = new File([this.initialFile], "import.xlsx");
					this.$emit("reset-initial-file");
				}
			}
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async upload() {
			if (!this.file) return;
			if (this.uploading) return;
			this.uploading = true;
			try {
				if (this.isExcelFile){
					var job = await PriceListProductService.importPriceListProductsExcel(this.file, this.productMatchingMethod, this.supplier);
				}else{
					var job = await PriceListProductService.importPriceListProductsCSV(this.file, this.useCommaSeperator, this.productMatchingMethod, this.supplier);
				}
				this.$emit("job", job);
				this.$emit("close");
			} catch (hErr) {
				let err = hErr as HttpError;
				if (err.message.startsWith("Unkown error: Invalid col")) {
					this.$wf.notify(this.$ct("csv-import-invalid-cols"), "danger", 3000, "exclamation-triangle");
				}
			}
			this.uploading = false;
		},
		onModalInput(value:boolean){
			if (!value) return;
			this.close();
		}
	},
	components: {
		AppFileUpload,
		AppMissingModule,
		AppContactSearch,
		AppProductMatchingMethodSelect
	},
	i18nEx: {
		componentPrefix: "components.price-lists"
	}
});
